import React from "react";
import "./Hero.css";
function Hero() {
  
  return (
    <div className="room-hero heroBanner">
      <div className="container">
        <div className="row">
          <div className="col-lg-8 col-md-10 m-auto">
            <div className="banner-content text-center">
                <h1 className="p-fair ">Classic Comfort</h1>
                <h2 className="pt-4">‎Seamless blend of tradition and luxury.</h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Hero;
